module.exports = __webpack_public_path__ + "img/DOWNLOAD.95239466.svg";